import 'css-chunk:../../frontend/phi3d/src/js/components/Aside/MoreHelp/index.module.scss';export default {
  "img": "_img_1p0e1_1",
  "button": "_button_1p0e1_14",
  "container": "_container_1p0e1_18"
};